import { useContext } from 'react';

export const useContextSafe = <T,>(context: React.Context<T>) => {
  const value = useContext(context);
  if (value === undefined) throw new Error('DEV: useContextSafe: value is undefined');
  return value;
};